// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   FILTER BAR (slides down when opened)
========================================= */

.CustomFilter_filterPanel__jaNbm {
    z-index: 1;
    transform-origin: top center;
}

.CustomFilter_filterPanel__jaNbm[hidden] {
    display: none !important;
}

.CustomFilter_filterPanelOpen__lrdPc {
    animation: CustomFilter_filterSlideDown__2xsAt 0.25s ease-out;
}

@keyframes CustomFilter_filterSlideDown__2xsAt {
    from {
        opacity: 0;
        transform: translateY(-8px) scaleY(0.97);
    }

    to {
        opacity: 1;
        transform: translateY(0) scaleY(1);
    }
}

/* respect users who turn animations off */
@media (prefers-reduced-motion: reduce) {
    .CustomFilter_filterPanelOpen__lrdPc {
        animation: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/DeviceHealth/Filter/CustomFilter.module.css"],"names":[],"mappings":"AAAA;;2CAE2C;;AAE3C;IACI,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6DAAyC;AAC7C;;AAEA;IACI;QACI,UAAU;QACV,wCAAwC;IAC5C;;IAEA;QACI,UAAU;QACV,kCAAkC;IACtC;AACJ;;AAEA,0CAA0C;AAC1C;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* =========================================\n   FILTER BAR (slides down when opened)\n========================================= */\n\n.filterPanel {\n    z-index: 1;\n    transform-origin: top center;\n}\n\n.filterPanel[hidden] {\n    display: none !important;\n}\n\n.filterPanelOpen {\n    animation: filterSlideDown 0.25s ease-out;\n}\n\n@keyframes filterSlideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-8px) scaleY(0.97);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scaleY(1);\n    }\n}\n\n/* respect users who turn animations off */\n@media (prefers-reduced-motion: reduce) {\n    .filterPanelOpen {\n        animation: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterPanel": `CustomFilter_filterPanel__jaNbm`,
	"filterPanelOpen": `CustomFilter_filterPanelOpen__lrdPc`,
	"filterSlideDown": `CustomFilter_filterSlideDown__2xsAt`
};
export default ___CSS_LOADER_EXPORT___;
